import { render, staticRenderFns } from "./LabelBagModificationModal.vue?vue&type=template&id=0c3354da&scoped=true&"
import script from "./LabelBagModificationModal.vue?vue&type=script&lang=js&"
export * from "./LabelBagModificationModal.vue?vue&type=script&lang=js&"
import style0 from "./LabelBagModificationModal.vue?vue&type=style&index=0&id=0c3354da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3354da",
  null
  
)

export default component.exports